import { createApp } from "vue";
// import VueGtagPlugin from "vue-gtag";
import App from "./App.vue";

createApp(App)
  // .use(VueGtagPlugin, {
  //   config: {
  //     id: "G-ZVMJ0JBFRW",
  //   },
  // })
  .mount("#app");
